import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['OnDemandStaffProfessionalShiftHistory']
});

const onDemandStaffProfessionalShiftHistoryApi = apiWithTags.injectEndpoints({
	tagTypes: ['OnDemandStaffProfessionalShiftHistory'],
	endpoints: (build) => ({
		// `from` / `to` are YYYY-MM-DD and optional; left out, the whole history comes back.
		getOnDemandStaffProfessionalShiftHistory: build.query({
			query: ({ caregiverId, managementCompanyId, from, to }) => ({
				url: `on-demand-staff/management-companies/${managementCompanyId}/professionals/${caregiverId}/shift-history`,
				params: { ...(from && { from }), ...(to && { to }) },
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['OnDemandStaffProfessionalShiftHistory']
		})
	})
});

export const { useGetOnDemandStaffProfessionalShiftHistoryQuery } = onDemandStaffProfessionalShiftHistoryApi;

export default onDemandStaffProfessionalShiftHistoryApi;
